<template>
  <div>
    <header class="header">
      <div class="button-back" @click="goBack">
        <span class="btn-icon fa fa-long-arrow-left"></span>
      </div>
      <div>
        <div class="film-title-wrapper">
          <h1 class="title">{{ title }}</h1>
          <span v-if="age" class="age">{{ age }}+</span>
        </div>
        <div class="film-genre">{{ genre }}</div>
      </div>
    </header>
    <div class="film-info">
      <section class="main-info">
        <img v-if="image" class="poster-image" :src="image" alt="" />
        <div class="main-info-film">
          <div v-if="genre" class="info-wrapper">
            <h2 class="label">Жанр:</h2>
            <p class="info">{{ genre }}</p>
          </div>
          <div v-if="duration !== ' '" class="info-wrapper">
            <h2 class="label">Продолжительность:</h2>
            <p class="info">{{ duration }}</p>
          </div>
          <div v-if="country" class="info-wrapper">
            <h2 class="label">Страна:</h2>
            <p class="info">{{ country }}</p>
          </div>
          <div v-if="director" class="info-wrapper">
            <h2 class="label">Режиссер:</h2>
            <p class="info">{{ director }}</p>
          </div>
          <div v-if="actors" class="info-wrapper">
            <h2 class="label">Актеры:</h2>
            <p class="info">{{ actors }}</p>
          </div>
        </div>
      </section>
      <section v-if="text" class="description-wrapper">
        <h2 class="label">Описание:</h2>
        <p class="info">{{ text }}</p>
      </section>
    </div>
    <div class="film-scheduler">
      <section class="schedule-date">
        <div class="form-group-date">
          <div @click="openTimePanel" class="date">{{ dateFormat }}</div>
          <div class="date-picker" v-if="showTimePanel">
            <DatePicker
              name="selectDate"
              v-model="data.scheduleForm.selectDate"
              format="YYYY-MM-DD"
              type="date"
              placeholder="Дата"
              @change="changeDate"
              :disabled-date="disabledBeforeTodayAndAfterAWeek"
              lang="ru"
              inline
            />
          </div>
        </div>
      </section>
      <section>
        <div class="schedule-theatres">
          <div
            v-if="filmWithSchedule"
            v-for="theatre in theatres"
            :key="theatre.Id"
            class="schedule-theatre"
          >
            <div>
              <div class="schedule-theatre-name">{{ theatre.Name }}</div>
              <div class="schedule-theatre-city">{{ theatre.Address }}</div>
            </div>
            <TimesByFormat
              v-for="(format, index) in Object.keys(theatre.TimesByFormat)"
              :theatre="theatre"
              :movieId="filmWithSchedule.Id"
              :format="format"
              :key="index"
            />
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
import TimesByFormat from '../GeneralSchedule/Movie/TimesByFormat/TimesByFormat';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import 'vue2-datepicker/locale/ru';
import urlQueryParts from '../../helpers/urlQueryParts';

export default {
  name: 'filmSchedule',
  components: { TimesByFormat, DatePicker },
  data() {
    return {
      date: null,
      image: null,
      showTimePanel: false,
    };
  },
  computed: {
    ...mapState({
      data: (state) => state.data,
      user: (state) => state.user,
      filmWithSchedule: (state) => state.data.filmWithSchedule,
      age: (state) => state.data.filmWithSchedule.Age,
      genre: (state) => state.data.filmWithSchedule.Genre,
      text: (state) => state.data.filmWithSchedule.Text,
      title: (state) => state.data.filmWithSchedule.Title,
      director: (state) => state.data.filmWithSchedule.Director,
      actors: (state) => state.data.filmWithSchedule.Actors,
      duration: (state) => {
        function declOfNum(number, titles) {
          let cases = [2, 0, 1, 1, 1, 2];
          return titles[
            number % 100 > 4 && number % 100 < 20
              ? 2
              : cases[number % 10 < 5 ? number % 10 : 5]
          ];
        }

        const time = state.data.filmWithSchedule.Duration;

        const hours = Math.floor(time / 60)
          ? `${Math.floor(time / 60)} ${declOfNum(Math.floor(time / 60), [
              'час',
              'часа',
              'часов',
            ])}`
          : '';
        const minutes = Math.floor(time % 60)
          ? `${Math.floor(time % 60)} ${declOfNum(Math.floor(time % 60), [
              'минута',
              'минуты',
              'минут',
            ])}`
          : '';

        return `${hours} ${minutes}`;
      },
      country: (state) => state.data.filmWithSchedule.Country,
    }),

    dateFormat() {
      const date = this.date || new Date(this.data.scheduleForm.selectDate);
      return [
        new Date(date).getFullYear(),
        new Date(date).getMonth() + 1 < 10
          ? '0' + (new Date(date).getMonth() + 1)
          : new Date(date).getMonth() + 1,
        new Date(date).getDate(),
      ]
        .reverse()
        .join('.');
    },

    theatres() {
      if (!this.filmWithSchedule) return [];

      const { theatreId, crmSystemId, theatres } = {
        ...this.data.afterUnmountedGeneralSchedule,
      };

      const queryTheaterId = this.$route.query.theaterId;

      return this.filmWithSchedule.Theatres.filter((theatre) => {
        if (theatreId) return theatre.Id === theatreId;
        if (queryTheaterId) return theatre.Id === queryTheaterId;
        else if (crmSystemId) {
          const crmTheatres = this.data.cities[0].Theatres.map(
            (theatre) => theatre.Id,
          );
          return crmTheatres.includes(theatre.Id);
        } else if (theatres) return theatres.split(',').includes(theatre.Id);

        return theatre;
      });
    },
  },
  methods: {
    goBack() {
      const { theatreId, crmSystemId, theatres, cityId } = {
        ...this.data.afterUnmountedGeneralSchedule,
      };

      if (theatreId || crmSystemId || theatres) {
        this.$router.push(
          `/generalSchedule${urlQueryParts({
            cityId,
            theatreId,
            crmSystemId,
            theatres,
          })}`,
        );
      } else {
        this.$router.push(`/generalSchedule/${this.$route.query.cityId}`);
      }
    },
    changeDate() {
      this.showTimePanel = false;
      this.date = null;
      const cityId = this.$route.query.cityId;
      const filmId = this.$route.query.filmId;
      const selectDate = this.data.scheduleForm.selectDate;
      const date = JSON.stringify(
        new Date(selectDate.getTime() - selectDate.getTimezoneOffset() * 60000),
      )
        .split('T')[0]
        .split('"')[1];

      this.$store.dispatch('updateFilmWthSchedule', { cityId, filmId, date });
    },
    openTimePanel() {
      this.showTimePanel = !this.showTimePanel;
    },
    disabledBeforeTodayAndAfterAWeek(date) {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      return (
        date < today ||
        date > new Date(today.getTime() + 365 * 24 * 3600 * 1000)
      );
    },
    loadPage() {
      const cityId = this.$route.query.cityId;
      const filmId = this.$route.query.filmId;
      const date = this.date;

      if (cityId && filmId && date) {
        this.$store.dispatch('filmScheduleOpen', { cityId, filmId, date });
      } else {
        this.$router.push('/generalSchedule');
      }
    },
  },
  beforeDestroy() {
    this.$store.commit('RESET_FILM_WITH_SCHEDULE');
  },
  mounted() {
    this.$store.commit('SET_START_FROM_SCHEDULE');

    let dateNow = new Date();
    if (this.$route.query.date === '') {
      dateNow = new Date(this.data.scheduleForm.selectDate);
    } else {
      const isInteger = Number.isInteger(+this.$route.query.date);

      if (isInteger) {
        dateNow = new Date(Number(this.$route.query.date));
      } else {
        const ruDateParse = (date) => {
          // Ожидает строку в формате DD.MM.YYYY
          if (typeof date !== 'string') return null;
          const parts = date.split('.');
          if (parts.length !== 3) return null;
          const [day, month, year] = parts.map(Number);
          if (
            isNaN(day) ||
            isNaN(month) ||
            isNaN(year) ||
            day < 1 ||
            day > 31 ||
            month < 1 ||
            month > 12 ||
            year < 1000
          )
            return null;
          return new Date(year, month - 1, day);
        };
        const parsedDate = ruDateParse(this.$route.query.date);
        if (parsedDate) {
          dateNow = parsedDate;
        }
      }

      this.$store.dispatch('changeFormForSchedule', {
        name: 'selectDate',
        dateNow,
      });
    }

    this.date = new Date(
      dateNow.getTime() - dateNow.getTimezoneOffset() * 60000,
    )
      .toJSON()
      .split('T')[0];

    if (this.user.sessionId) this.loadPage();

    this.image = this.data.filmWithSchedule.Image;
  },
  watch: {
    'user.sessionId': {
      handler() {
        this.loadPage();
      },
    },

    'data.filmWithSchedule.Image': {
      handler() {
        this.image =
          this.data.filmWithSchedule.Image ||
          'https://cdn.pzpreprod.66bit.ru/thumbs/9d39246906748e4990243fb3fe9ec334d652e3d0.jpg';
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.film-info {
  padding: 2rem;
  border-bottom: solid 1px #3d3d3d;
}

.film-scheduler {
  padding: 2rem;
}

.schedule-date {
  margin-bottom: 2rem;
}

.title {
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 600;
  font-size: 28px;
  line-height: 32px;
  display: flex;
  align-items: center;
  color: #ffffff;
}

.film-title-wrapper {
  width: fit-content;
  display: flex;
  align-items: center;
  gap: 1rem;
}

.age {
  background-color: #f49d1a;
  padding: 6px 12px;
  border-radius: 6px;
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 20px;
  display: flex;
  align-items: center;
  color: #ffffff;
}

.description-wrapper {
  margin-top: 2rem;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.film-genre {
  color: rgba(255, 255, 255, 0.53);
  font-size: 16px;
  line-height: 20px;
  margin-top: 0.25rem;
}

.button-back {
  box-sizing: border-box;
  overflow: hidden;
  color: #fff;
  cursor: pointer;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  top: 10px;
  width: 36px;
  height: 36px;
  border: 2px solid #fff;
  border-radius: 100%;
  opacity: 0.3;
  cursor: pointer;
  justify-content: center;
  transition: 0.15s ease-in-out;
  flex: 0 0 auto;

  &:hover {
    opacity: 1;
  }
}

.header {
  position: sticky;
  top: 0;
  display: flex;
  border-bottom: 1px solid rgba(255, 255, 255, 0.11);
  align-items: center;
  padding: 1rem 2rem;
  gap: 1.5rem;
}

.main-info {
  display: flex;
  flex-wrap: wrap;
  gap: 1.5rem 2.5rem;
}

.main-info-film {
  flex: 1;
}

.poster-image {
  width: 260px;
  object-fit: contain;
  border-radius: 12px;
}

.label {
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  color: #b3b3b3;
}

.info {
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 400;
  font-size: 20px;
  line-height: 24px;
  display: flex;
  align-items: center;
  color: #ffffff;
}

.info-wrapper {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.form-group-date {
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  display: flex;
  align-items: center;
  color: #ffffff;
  position: relative;
}

.date {
  font-family: 'Roboto', sans-serif;
  color: #fff;
  font-size: 1.5rem;
  padding-right: 0.75rem;
  cursor: pointer;
  position: relative;

  &:after {
    position: absolute;
    display: block;
    content: '';
    width: 24px;
    height: 24px;
    background: url('../../assets/calendar.png') no-repeat center;
    top: 50%;
    transform: translateY(-50%);
    right: -24px;
  }
}

.date-picker {
  position: absolute;
  top: 2rem;
  z-index: 9;
}

.schedule-theatres {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.schedule-theatre {
  display: flex;
  padding: 10px 0;
  width: 100%;
  flex-direction: column;
  gap: 1rem;
}

.schedule-theatre-name {
  font-family: 'Roboto';
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  color: #ffffff;
}

.schedule-theatre-city {
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 400;
  margin-bottom: auto;
  font-size: 16px;
  line-height: 20px;
  color: #b3b3b3;
  margin-top: 0.5rem;
}
</style>
